import omit from 'lodash-es/omit'
import * as Yup from 'yup'

import { getItemsIds } from '../../../utils/common'
import { getCleanValues } from '../../../utils/formHelpers'
import { hasFormikFormEmptyRequired } from '../../Formik'

import {
  BUILDING_GROUP_FORM_FIELD_NAME_BUILDINGS,
  BUILDING_GROUP_FORM_FIELD_NAME_MANAGERS,
  BUILDING_GROUP_FORM_FIELD_NAME_TITLE,
  BUILDING_GROUP_FORM_FIELD_NAME_UPDATE_MANAGERS,
} from './BuildingGroupForm.constants'

export function getValidationSchema() {
  return Yup.object({
    // .max(BUILDING_GROUP_FORM_FIELD_MANAGERS_MAX_LENGTH, true)
    // .nullable(), for next iteration
    [BUILDING_GROUP_FORM_FIELD_NAME_BUILDINGS]: Yup.array().of(Yup.object()),
    [BUILDING_GROUP_FORM_FIELD_NAME_MANAGERS]: Yup.array().of(Yup.object()),
    [BUILDING_GROUP_FORM_FIELD_NAME_TITLE]: Yup.string().trim().required(true),
    [BUILDING_GROUP_FORM_FIELD_NAME_UPDATE_MANAGERS]: Yup.boolean(),
  })
}

export function getPayload(values) {
  const payload = getCleanValues(values)

  if (payload[BUILDING_GROUP_FORM_FIELD_NAME_MANAGERS]?.length > 0) {
    payload[BUILDING_GROUP_FORM_FIELD_NAME_MANAGERS] = getItemsIds(
      payload[BUILDING_GROUP_FORM_FIELD_NAME_MANAGERS],
      'value'
    )
  }

  if (payload[BUILDING_GROUP_FORM_FIELD_NAME_BUILDINGS]?.length > 0) {
    payload[BUILDING_GROUP_FORM_FIELD_NAME_BUILDINGS] = getItemsIds(
      payload[BUILDING_GROUP_FORM_FIELD_NAME_BUILDINGS],
      'value'
    )
  }

  return payload
}

export function checkBuildingGroupFormForEmptyRequired(errors) {
  return hasFormikFormEmptyRequired(
    omit(errors, [BUILDING_GROUP_FORM_FIELD_NAME_MANAGERS])
  )
}
